export default __webpack_public_path__ + "static/media/logo.7ae8a675.png";